import React, { useEffect, useRef } from 'react';
import SmartLink from '../common/smart-link';
import styles from './mobile-menu.module.css';

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
}

export default function MobileMenu({ open, onClose }: MobileMenuProps) {
  const overlayRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const overlay = overlayRef.current;
    if (!overlay) return;
    // Manage body scroll when open
    if (open) {
      document.body.style.overflow = 'hidden';
    }
    else {
      document.body.style.overflow = '';
    }

    const onOutside = (e: MouseEvent) => {
      if (e.target === overlay) onClose();
    };
    overlay.addEventListener('click', onOutside);
    return () => {
      overlay.removeEventListener('click', onOutside);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  return (
    <div className={`${styles.overlay} ${open ? styles.active : ''}`} ref={overlayRef} aria-hidden={!open}>
      <button className={styles.closeButton} aria-label="Close mobile menu" onClick={onClose}>
        <span className={styles.closeIcon}>×</span>
      </button>

      <div className={styles.content}>
        <div className={styles.header}>
          <SmartLink href="#hero" className={styles.logoLink} onClick={onClose}>
            <h2>Meghan Rabbitt</h2>
          </SmartLink>
        </div>

        <div className={styles.separator}></div>

        <nav>
          <ul className={styles.navList}>
            {/* <li><SmartLink href="#about-book" className={styles.navLink} onClick={onClose}>Book</SmartLink></li> */}
            <li><SmartLink href="#order-header" className={`${styles.navLink} ${styles.preorderNavLink}`} onClick={onClose}>Get the Book</SmartLink></li>
            <li><SmartLink href="#subscribe" className={`${styles.navLink} ${styles.subscribeNavLink}`} onClick={onClose}>Subscribe</SmartLink></li>
            <li><SmartLink href="/media" className={`${styles.navLink} ${styles.navLink}`} onClick={onClose}>Media</SmartLink></li>
            {/* <li><SmartLink href="#events" className={styles.navLink} onClick={onClose}>Events</SmartLink></li> */}
            <li><SmartLink href="#contact" className={styles.navLink} onClick={onClose}>Contact</SmartLink></li>
            <li><SmartLink href="#about-author" className={styles.navLink} onClick={onClose}>About</SmartLink></li>

          </ul>
        </nav>
      </div>
    </div>
  );
}
